import { render, staticRenderFns } from "./ModalProcessoProgressao.vue?vue&type=template&id=2d30f85a&scoped=true"
import script from "./ModalProcessoProgressao.vue?vue&type=script&lang=js"
export * from "./ModalProcessoProgressao.vue?vue&type=script&lang=js"
import style0 from "./ModalProcessoProgressao.vue?vue&type=style&index=0&id=2d30f85a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d30f85a",
  null
  
)

export default component.exports